import { combineReducers } from "redux";
import { createItemReducer } from "@mnjsplatform/data/lib/reducers/dataItemReducer";
import * as types from "../actions/workDocumentsActions";
import * as errorActions from "@mnjsplatform/data/lib/actions/errorActions";

/*
Monolit.Personal:PersContract:PersContract_ListForPO;
Monolit.Personal:PersonalStage:PersonalStage_WorkStageForPO;
Monolit.Personal:PersonalStage:PersonalStage_WorkListForPO;
Monolit.Personal:PersJobDescExam:PersJobDescExam_ListForPersForPO;

 */

export default function workDocumentsReducer(
    state = {
        isLoaded: false,
        inOperation: false,
        isError: false,
        isAuthenticated: false,
        errorText: null,
        appParams: {},
        image: null
    },
        action
) {
    if (action.type === types.WORK_LIST_IMAGE_LOADED) {
        return Object.assign({}, state, {
            image: action.data.imagePagesLinks
        })
    } else if (action.type === errorActions.ERROR_RAISED) {
        return Object.assign({}, state, {
            image: null
        })
    }
    return state;
}

export function workDocumentsItems() {
    return combineReducers({
        PersContract_ListForPO: createItemReducer("WorkDocuments", "PersContract.ListForPO", false),
        PersonalStage_WorkStageForPO: createItemReducer("WorkDocuments", "PersonalStage.WorkStageForPO", false),
        PersonalStage_WorkListForPO: createItemReducer("WorkDocuments", "PersonalStage.WorkListForPONew", false),
        PersJobDescExam_ListForPersForPO: createItemReducer("WorkDocuments", "PersJobDescExam.ListForPersForPO", false),
        PersEmplBook_ListForPO: createItemReducer("WorkDocuments", "PersEmplBook.ListForPO", false),
        PersonalStage_WorkListForPONew_Slav: createItemReducer("WorkDocuments", "PersonalStage.WorkListForPONew_Slav", false),
        PersJobDescExam_ListForPersForArcPO: createItemReducer("WorkDocuments", "PersJobDescExam.ListForPersForArcPO", false)
    });
}